import React, { memo } from "react";
import { Stack, Typography, Card } from "investira.react.components";
import { validators } from "investira.sdk";
import CorrelacaoItens from "./CorrelacaoItens";
import { PATHS } from "../../../enums";

const CorrelacaoList = memo((props) => {
  const { itens } = props;

  if (validators.isNull(itens)) {
    return null;
  }

  const getUrl = (pItem) => {
    const xOrigem = pItem.item_origem;

    const xRoot = {
      ativo: "/ativos",
      indicador: "/indicadores",
    };

    const xId = pItem.ativo_id || pItem.pessoa_id || pItem.indicador_id;

    let xPath = "";

    if (pItem.mercado) {
      xPath = PATHS[pItem.mercado.toLowerCase()].path;
    }

    switch (xOrigem) {
      case "ativo":
        return `${xRoot[xOrigem]}${xPath}/${xId}`;
      default:
        return `${xRoot[xOrigem]}/${xId}`;
    }
  };

  return (
    <Card>
      <Stack px={2} py={2}>
        <Stack mb={2}>
          <Typography variant={"h6"}>Componentes</Typography>
        </Stack>
        <Stack>
          {Object.values(itens).map((xItem) => {
            const xUrl = getUrl(xItem);

            return (
              <CorrelacaoItens
                key={crypto.randomUUID()}
                data={xItem}
                url={xUrl}
              />
            );
          })}
        </Stack>
      </Stack>
    </Card>
  );
});

export default CorrelacaoList;
